<template>
	<div class="fd-mailtest-item" :class="localClass" >
		<div class="fd-mailtest-array">
			<api-error v-for="err in localErrors" tag="div" :level="err.level" :message="err.message" class="no-border e2e-padding"></api-error>
			<div class="fd-array-item">
				<div class="fd-array-item-content">
					<select  v-model="maTest.type" :disabled="ro">
					  <option v-for="item in typeList" :value="item.value">{{item.name}}</option>
					</select>
				</div>
			</div>
		<template v-if="maTest.type === 'SUBJECT' || maTest.type === 'BODY'">
			<div class="fd-array-item">
				<div>{{ env.msg('mailActionTest.contains') }}:</div>
				<div class="fd-array-item-content">
					<input type="text" v-model="maTest.match" :readonly="ro" :class="localInputClass">
				</div>
			</div>
		</template>
		<template v-if="maTest.type === 'ATTACHMENT'">
			<div class="fd-array-item">
				<div>{{ env.msg('mailActionTest.mimeType.contains') }}:</div>
				<div class="fd-array-item-content">	
					<input type="text" v-model="maTest.mime" placeholder="*/*" :readonly="ro" :class="localInputClass">
				</div>
			</div>
		</template>
		<template v-if="maTest.type === 'REF'">
			<div class="fd-array-item">
				<div>{{ env.msg('changelog.srcType') }}:</div>
				<div class="fd-array-item-content">
					<select v-model.number="maTest.srcType" :disabled="ro" :class="localInputClass">
						<option v-for="item in srcTypeList" :value="item.value">{{item.name}}</option>
					</select>
				</div>
			</div>
			<div class="fd-array-item">
				<div>{{ env.msg('changelog.srcId') }}:</div>
				<div class="fd-array-item-content">
					<input type="number" v-model.number="maTest.srcId" :readonly="ro" :class="localInputClass">
				</div>
			</div>
		</template>
		<template v-if="maTest.type === 'RECIPIENT'">
			<div class="fd-array-item">
				<div class="fd-array-item-content">
					<label>
						<input type="checkbox" v-model="maTest.multiple" :readonly="ro" :class="localInputClass"/>
						{{env.msg('mailActionTest.recipient.more')}}
					</label>
				</div>
			</div>
			<div class="fd-array-item">
				<div>{{ env.msg('mailActionTest.contains') }}:</div>
				<div class="fd-array-item-content">
					<input type="text" v-model="maTest.is" :readonly="ro" :class="localInputClass">
				</div>
			</div>
		</template>
		<template v-if="maTest.type === 'SENDER'">
			<div class="fd-array-item">
				<div>{{ env.msg('mailActionTest.contains') }}:</div>
				<div class="fd-array-item-content">
					<input type="text" v-model="maTest.is" :readonly="ro" :class="localInputClass">
				</div>
			</div>
		</template>
		<template v-if="maTest.type === 'PRIORITY'">
			<div class="fd-array-item">
				<div>{{ env.msg('mail.priority') }}:</div>
				<div class="fd-array-item-content">
					<select v-model="maTest.is" :disabled="ro" :class="localInputClass">
						<option value="low">{{ env.msg('list.mail.priority.low') }}</option>
						<option value="norm">{{ env.msg('list.mail.priority.normal') }}</option>
						<option value="high">{{ env.msg('list.mail.priority.high') }}</option>
					</select>
				</div>
			</div>
		</template>
		<template v-if="maTest.type === 'HEADER'">
			<div class="fd-array-item">
				<div>{{ env.msg('th.name') }}:</div>
				<div class="fd-array-item-content">
					<input type="text" v-model="maTest.name" :readonly="ro" :class="localInputClass">
				</div>
			</div>
			<div class="fd-array-item">
				<div>{{ env.msg('mailActionTest.contains') }}:</div>
				<div class="fd-array-item-content">
					<input type="text" v-model="maTest.match" :readonly="ro" :class="localInputClass">
				</div>
			</div>
		</template>
		<template v-if="maTest.type === 'VACATION' || maTest.type === 'HEAD' || maTest.type === 'ALWAYS'">
			<!-- div class="fd-array-item">
				<div class="fd-array-item-content"><sym-icon name="yes"/></div>
			</div -->
		</template>
		<template v-if="maTest.type === 'NOT'">
			<div class="fd-array-item">
				<div><sym-icon name="not"/></div>
				<div class="fd-array-item-content">
					<mail-action-test-editor :value="maTest.test" @update-value="updateValueTest"
							:error-path='errorPath+".test"' :ro="ro"/>
				</div>
			</div>
		</template>
		<template v-if="maTest.type === 'AND' || maTest.type === 'OR'">
			<div class="fd-array-item">
				<div><sym-icon :name="joinIcon(maTest.type)"/></div>
				<div class="fd-array fd-filter-array">
					<div class="fd-array-item">
						<mail-action-test-editor :value="maTest.left" @update-value="updateValueLeft" 
							 :error-path='errorPath+".left"' :ro="ro" />
					</div>
					<div class="fd-array-item">
						<mail-action-test-editor :value="maTest.right" @update-value="updateValueRight"
							 :error-path='errorPath+".right"' :ro="ro" />
					</div>
				</div>
			</div>
		</template>
		<template v-if="maTest.type === 'CLASS'">
			<div class="fd-array-item">
				<div>{{ env.msg('mailActionTest.class.contains') }}:</div>
				<div class="fd-array-item-content">
					<cats-part :part="classPartDef" :data="maTest" :class="localInputClass" :readonly="ro"></cats-part>
				</div>
			</div>
		</template>
		</div>
	</div>
</template>

<script setup lang="ts">
	import {computed, ref, onMounted, reactive, watch} from "vue";
	import type {MailActionTest} from "@t/mail/MailAction";
	import {injectEnv} from "@fd/Environment";
	import {useListStore} from "@/store/ListStore.ts";
	import CatsPart from '@/fd/editors/CatsPart.vue';
	import SymIcon from "@/fd/helpers/SymIcon.vue";
	import ApiError from "@/fd/helpers/ApiError.vue";
	import {ErrorMap, injectErrors} from "@/fd/PartInjectKeys.ts";
	
	const props = defineProps<{
	  value: MailActionTest|undefined; 
	  ro: boolean;
	  errorPath: string;
	}>();
	
	const emit = defineEmits(['updateValue']);
	
	const env = injectEnv();
	const ls = useListStore();
	
	const maTest = ref<MailActionTest>(props.value ?? { type: "ALWAYS" });
	const classPartDef = { property: "anyOf" , list: "com.anneca.intouch.list.MailClassList"};

	const typeList = ls.findList("com.anneca.intouch.list.MailActionTestTypeList");
	const srcTypeList = ls.findList("com.anneca.intouch.list.SrcTypeList[useFor=3]");
	const errorMap = injectErrors();
	
	const localErrors = computed<ErrorMap>(() => {
		const filtered:ErrorMap = [];
		for (let err of errorMap.value) {
			if (err.field === props.errorPath) {
				filtered.push(err);
			}
		}
		return filtered;
	});
	
	const localClass = computed(() => {
		return localErrors.value.length > 0 ? "invalid-rule":"valid-rule";
	});
	
	const localInputClass = computed(() => {
		return localErrors.value.length > 0 ? "invalid":"";
	});
	
	function joinIcon(testType: string):string {
		if (testType=="AND") return "and";
		else if (testType=="OR") return "or";
		else return "empty-18";
	}
	
	function updateValueTest(test: MailActionTest): void {
		maTest.value.test = test;
	}
	function updateValueLeft(test: MailActionTest): void {
		maTest.value.left = test;
	}
	function updateValueRight(test: MailActionTest): void {
		maTest.value.right = test;
	}
	
	function resetToNewType(newType: string): void {
		maTest.value = { type: newType };
		if (newType === "CLASS") {
			maTest.value.anyOf=[];
		}
	}
	
	function resetToGroupType(newType: string, oldType: string): void {
		var oldTest = JSON.parse(JSON.stringify(maTest.value));
		oldTest.type = oldType;
		maTest.value = { type: newType, left: oldTest, right: { type: "ALWAYS"}};
		console.log("New group test:"+JSON.stringify(maTest.value));
	}
	
	watch(maTest, (newValue, oldValue) => {	
			emit('updateValue', maTest.value);
			//console.log("emit update");
		},
		{ deep: true, flush: 'post' }
	);
	
	watch(
		() => maTest.value.type,
		(newType,oldType) => {
			console.log(`Changed type: ${newType} vs old: ${oldType}`);
			if (newType === 'AND' || newType === 'OR') {
				resetToGroupType(newType, oldType);
			}
			else {
				resetToNewType(newType);
			}
		}
	);
</script>

